module.exports = __webpack_public_path__ + "static/media/fuselage_image2.25896ca7.png";